import { Navigate, Route, Routes } from 'react-router-dom';
import { RoutePaths } from '@shared/utils';
import { PageLayout } from '@widgets';
import { AccountsPage, Cards, ContactUs, Dashboard, Messages, PaymentsPage } from '@pages';

export const Private = () => {
  return (
    <Routes>
      <Route element={<PageLayout />}>
        <Route path={RoutePaths.dashboard.path} element={<Dashboard />} />
        <Route path={RoutePaths.accounts.path} element={<AccountsPage />} />
        <Route path={RoutePaths.cards.path} element={<Cards />} />
        <Route path={RoutePaths.payments.path} element={<PaymentsPage />} />
        <Route path={RoutePaths.contactUs.path} element={<ContactUs />} />
        <Route path={RoutePaths.messages.path} element={<Messages />} />
      </Route>
      <Route path='*' element={<Navigate to={RoutePaths.dashboard.onNavigate()} />} />
    </Routes>
  );
};
